export default {
  placeholder: 'Rechercher une adresse',
  edit: 'Modifier l\' adresse',
  manualEntry: 'Saisir l\'adresse manuellement',
  cancelButton: 'Annuler',
};
